<div class="modal-header card-header cabecera">
    <span class="text-blue text-125 mr-3">Reportes de campo</span>
    <div class="d-flex align-items-center flex-wrap filtros">
        <label class="mb-0">Del</label>
        <input type="date" class="form-control form-control-sm" name="desde" [(ngModel)]="desde">
        <label class="mb-0">al</label>
        <input type="date" class="form-control form-control-sm" name="hasta" [(ngModel)]="hasta">
        <select class="form-control form-control-sm" name="sucursal" [(ngModel)]="id_sucursal" *ngIf="sucursales.length > 1">
            <option [ngValue]="0">Todas las sucursales</option>
            <option *ngFor="let s of sucursales" [ngValue]="s.id">{{ s.nombre }}</option>
        </select>
        <button type="button" class="btn btn-primary btn-sm" (click)="buscar()" title="Buscar">
            <i class="fa fa-search" [class.fa-spin]="cargando || cargandoColegios"></i>
        </button>
        <button type="button" class="btn btn-success btn-sm" (click)="exportarExcel()" [disabled]="!asesores.length && !colegios.length" title="Descargar Excel">
            <i class="fa fa-file-excel"></i>
        </button>
        <button type="button" class="btn btn-danger btn-sm" (click)="exportarPdf()" [disabled]="pestana === 'colegios' ? !colegios.length : !asesores.length" title="Descargar PDF">
            <i class="fa fa-file-pdf"></i>
        </button>
    </div>
    <button type="button" class="btn btn-light btn-sm ml-auto" (click)="activeModal.close()" title="Cerrar">
        <i class="fa fa-times"></i>
    </button>
</div>

<div class="modal-body">
    <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
            <a class="nav-link" href="javascript:void(0)" [class.active]="pestana === 'equipo'" (click)="cambiarPestana('equipo')">Resumen del equipo</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" href="javascript:void(0)" [class.active]="pestana === 'detalle'" (click)="cambiarPestana('detalle')">Detalle por asesor</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" href="javascript:void(0)" [class.active]="pestana === 'mensual'" (click)="cambiarPestana('mensual')">Resumen mensual</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" href="javascript:void(0)" [class.active]="pestana === 'colegios'" (click)="cambiarPestana('colegios')">Visitas por colegio</a>
        </li>
    </ul>

    <div *ngIf="cargando" class="text-center py-4"><i class="fa fa-spinner fa-spin fa-2x"></i></div>

    <div *ngIf="!cargando && !asesores.length && pestana !== 'colegios'" class="text-muted py-3">
        No hay asesores para controlar: tienen que estar registrados como empleados, con turnos y con "Geo auto" en su usuario.
    </div>

    <!-- ---------- B. Resumen diario del equipo ---------- -->
    <div *ngIf="!cargando && asesores.length && pestana === 'equipo'" class="table-responsive">
        <table class="table table-sm table-bordered table-hover tabla">
            <thead>
                <tr>
                    <th>Asesor</th>
                    <th>Fecha</th>
                    <th>Ingreso {{ nombresTurnos[0] | lowercase }}</th>
                    <th>Salida {{ nombresTurnos[0] | lowercase }}</th>
                    <th>Ingreso {{ nombresTurnos[1] | lowercase }}</th>
                    <th>Salida {{ nombresTurnos[1] | lowercase }}</th>
                    <th>Lugares</th>
                    <th>Horas esperadas</th>
                    <th>Horas reconocidas</th>
                    <th>%</th>
                    <th>Resultado</th>
                    <th>Ajustes</th>
                    <th>Alertas</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let f of filas" (click)="verDetalle(f)" class="fila" title="Ver el detalle de visitas">
                    <td>{{ f.asesor.nombre }}</td>
                    <td class="text-nowrap">{{ fecha(f.dia.fecha) }}</td>
                    <td [class.text-danger]="turno(f.dia, 0)?.atraso">{{ hora(turno(f.dia, 0)?.ingreso) }}</td>
                    <td [class.text-danger]="turno(f.dia, 0)?.salida_anticipada">{{ hora(turno(f.dia, 0)?.salida) }}</td>
                    <td [class.text-danger]="turno(f.dia, 1)?.atraso">{{ hora(turno(f.dia, 1)?.ingreso) }}</td>
                    <td [class.text-danger]="turno(f.dia, 1)?.salida_anticipada">{{ hora(turno(f.dia, 1)?.salida) }}</td>
                    <td class="text-center">{{ lugaresDia(f.dia) }}</td>
                    <td class="text-right">{{ horas(f.dia.minutos_esperados) }}</td>
                    <td class="text-right font-weight-bold">{{ horas(f.dia.minutos_reconocidos) }}</td>
                    <td class="text-right">{{ porcentaje(f.dia.cumplimiento) }}</td>
                    <td><span class="badge" [ngClass]="claseResultado(f.dia.resultado)">{{ f.dia.resultado }}</span></td>
                    <td class="ajustes">{{ textoAjustesDia(f.dia) }}</td>
                    <td class="alertas">
                        <div *ngFor="let a of f.dia.alertas">{{ a }}</div>
                    </td>
                </tr>
                <tr *ngIf="!filas.length">
                    <td colspan="13" class="text-muted text-center">Sin turnos ni marcaciones en estas fechas.</td>
                </tr>
            </tbody>
        </table>
        <small class="text-muted">Tocá una fila para ver el detalle de las visitas de ese día.</small>
    </div>

    <!-- ---------- E. Visitas por colegio ---------- -->
    <div *ngIf="pestana === 'colegios'">
        <div *ngIf="cargandoColegios" class="text-center py-4"><i class="fa fa-spinner fa-spin fa-2x"></i></div>
        <ng-container *ngIf="!cargandoColegios">
            <div class="d-flex align-items-center flex-wrap mb-2 filtros">
                <input type="text" class="form-control form-control-sm buscador" name="filtro_colegio" [(ngModel)]="filtroColegio"
                    placeholder="Buscar colegio o asesor" aria-label="Buscar colegio o asesor">
                <span class="text-muted">
                    {{ colegios.length }} lugares visitados · {{ colegiosSinVisitas.length }} clientes sin visitas · del {{ desde }} al {{ hasta }} (hasta un año)
                </span>
            </div>
            <div class="table-responsive">
                <table class="table table-sm table-bordered table-hover tabla">
                    <thead>
                        <tr>
                            <th>Colegio</th>
                            <th class="text-center">Visitas</th>
                            <th class="text-center">Días</th>
                            <th>Asesores (visitas)</th>
                            <th>Última visita</th>
                            <th class="text-center">Tiempo promedio</th>
                            <th class="text-center">Marcas lejos</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let c of colegiosFiltrados()">
                            <td>
                                {{ c.lugar }}
                                <span *ngIf="c.es_otro" class="badge badge-light">otro lugar</span>
                                <span *ngIf="!c.es_otro && !c.con_ubicacion" class="badge badge-warning">sin ubicación</span>
                                <small *ngIf="c.direccion" class="d-block text-muted">{{ c.direccion }}</small>
                            </td>
                            <td class="text-center font-weight-bold">{{ c.visitas }}</td>
                            <td class="text-center">{{ c.dias }}</td>
                            <td>
                                <div *ngFor="let a of c.asesores">{{ a.nombre }} <span class="text-muted">({{ a.visitas }})</span></div>
                            </td>
                            <td class="text-nowrap">
                                {{ fechaHora(c.ultima) }}
                                <small class="d-block text-muted">{{ c.ultimo_asesor }}</small>
                            </td>
                            <td class="text-center">{{ minutos(c.minutos_promedio) }}</td>
                            <td class="text-center" [class.text-danger]="c.lejos">{{ c.lejos || '' }}</td>
                        </tr>
                        <tr *ngIf="!colegiosFiltrados().length">
                            <td colspan="7" class="text-muted text-center">Sin visitas en estas fechas.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <a href="javascript:void(0)" (click)="verSinVisitas = !verSinVisitas" *ngIf="colegiosSinVisitas.length">
                <i class="fa" [class.fa-chevron-down]="!verSinVisitas" [class.fa-chevron-up]="verSinVisitas"></i>
                Clientes sin visitas en el período ({{ sinVisitasFiltrados().length }})
            </a>
            <table *ngIf="verSinVisitas" class="table table-sm table-bordered tabla mt-2">
                <tbody>
                    <tr *ngFor="let c of sinVisitasFiltrados()">
                        <td>
                            {{ c.lugar }}
                            <span *ngIf="!+c.con_ubicacion" class="badge badge-warning">sin ubicación</span>
                        </td>
                        <td class="text-muted">{{ c.direccion }}</td>
                    </tr>
                </tbody>
            </table>
        </ng-container>
    </div>

    <!-- ---------- C. Resumen mensual ---------- -->
    <div *ngIf="!cargando && asesores.length && pestana === 'mensual'">
        <div class="d-flex align-items-center flex-wrap mb-2 filtros">
            <label class="mb-0" for="mes_resumen">Mes</label>
            <input id="mes_resumen" type="month" class="form-control form-control-sm mes" name="mes" [(ngModel)]="mes" (change)="elegirMes()">
            <span class="text-muted">o el rango de arriba: del {{ desde }} al {{ hasta }}</span>
        </div>
        <div class="table-responsive">
            <table class="table table-sm table-bordered table-hover tabla">
                <thead>
                    <tr>
                        <th>Asesor</th>
                        <th *ngFor="let c of columnasMensual" class="text-center">{{ c[0] }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let a of asesores" class="fila" (click)="asesorDetalle = a; diaDetalle = ''; pestana = 'detalle'" title="Ver el detalle del asesor">
                        <td class="text-nowrap">
                            {{ a.nombre }}
                            <small *ngIf="a.sin_turnos" class="d-block text-danger">sin turnos</small>
                        </td>
                        <td *ngFor="let c of columnasMensual" class="text-right text-nowrap" [class.font-weight-bold]="c[2] !== 'n'">{{ valorMensual(a.resumen, c) }}</td>
                    </tr>
                    <tr *ngIf="totalEquipo" class="total">
                        <td>Total del equipo</td>
                        <td *ngFor="let c of columnasMensual" class="text-right text-nowrap">{{ valorMensual(totalEquipo, c) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <small class="text-muted">Los días en curso no se cuentan hasta que terminan. El incentivo se agrega cuando Administración lo defina.</small>
    </div>

    <!-- ---------- A. Detalle diario por asesor ---------- -->
    <div *ngIf="!cargando && asesores.length && pestana === 'detalle'">
        <div class="d-flex align-items-center flex-wrap mb-3 filtros">
            <label class="mb-0">Asesor</label>
            <select class="form-control form-control-sm selector-asesor" name="asesor" [(ngModel)]="asesorDetalle">
                <option *ngFor="let a of asesores" [ngValue]="a">{{ a.nombre }} ({{ a.usuario }})</option>
            </select>
            <a *ngIf="diaDetalle" href="javascript:void(0)" (click)="diaDetalle = ''">Ver todo el rango</a>
            <span *ngIf="asesorDetalle?.sin_turnos" class="text-danger">Este asesor no tiene turnos asignados.</span>
        </div>

        <div *ngFor="let dia of diasDetalle()" class="dia">
            <div class="dia-cabecera">
                <b>{{ fecha(dia.fecha) }}</b>
                <span class="badge" [ngClass]="claseResultado(dia.resultado)">{{ dia.resultado }}</span>
                <span>{{ horas(dia.minutos_reconocidos) }} h reconocidas de {{ horas(dia.minutos_esperados) }} h · {{ porcentaje(dia.cumplimiento) }}</span>
                <button type="button" class="btn btn-outline-success btn-sm ml-auto" (click)="verMapa(dia)" *ngIf="dia.turnos.length">
                    <i class="fa fa-map-marked-alt"></i> Ver mapa
                </button>
                <button type="button" class="btn btn-outline-primary btn-sm" (click)="abrirAjuste(dia)" *ngIf="ajuste?.fecha !== fechaDia(dia)">
                    <i class="fa fa-pen"></i> Ajustar día
                </button>
            </div>

            <div *ngIf="dia.feriado" class="ajuste-linea">
                <span class="badge badge-light">Feriado</span> {{ dia.feriado }}
                <small class="text-muted">(de la empresa; se cambia en Control de campo)</small>
            </div>
            <div *ngFor="let a of dia.ajustes" class="ajuste-linea">
                <span class="badge badge-primary">{{ nombreTipoAjuste(a.tipo) }}</span>
                {{ textoAjuste(dia, a) }}
                <small class="text-muted">· {{ a.usuario }} {{ a.registrado | date: 'dd/MM/yyyy HH:mm' }}</small>
                <a href="javascript:void(0)" class="text-danger ml-2" (click)="quitarAjuste(a)">Quitar</a>
            </div>

            <form *ngIf="ajuste && ajuste.fecha === fechaDia(dia)" class="ajuste-formulario" (ngSubmit)="guardarAjuste()">
                <div class="d-flex align-items-center flex-wrap filtros">
                    <select class="form-control form-control-sm" name="tipo_ajuste" [(ngModel)]="ajuste.tipo" aria-label="Tipo de ajuste">
                        <option *ngFor="let t of tiposAjuste" [ngValue]="t.codigo">{{ t.nombre }}</option>
                    </select>
                    <select class="form-control form-control-sm" name="turno_ajuste" [(ngModel)]="ajuste.id_turno" aria-label="Turno">
                        <option [ngValue]="null">Todo el día</option>
                        <option *ngFor="let t of ajuste.turnos" [ngValue]="t.id_turno">{{ t.nombre }}</option>
                    </select>
                    <input *ngIf="ajuste.tipo === 'PERMISO'" type="number" min="1" class="form-control form-control-sm minutos" name="minutos_ajuste"
                        [(ngModel)]="ajuste.minutos" placeholder="Minutos" aria-label="Minutos del permiso">
                    <input type="text" class="form-control form-control-sm motivo" name="observacion_ajuste" [(ngModel)]="ajuste.observacion"
                        placeholder="Motivo (obligatorio)" maxlength="500" aria-label="Motivo del ajuste">
                    <button type="submit" class="btn btn-primary btn-sm" [disabled]="guardandoAjuste">Guardar</button>
                    <button type="button" class="btn btn-light btn-sm" (click)="ajuste = null">Cancelar</button>
                </div>
                <small class="text-muted">{{ ayudaAjuste() }} Si ya hay un ajuste para ese día y turno, lo reemplaza.</small>
            </form>

            <div *ngFor="let t of dia.turnos" class="turno">
                <div class="turno-cabecera">
                    <b>{{ t.nombre }}</b> {{ t.inicio_oficial }}–{{ t.fin_oficial }}
                    <span *ngIf="t.es_reunion" class="badge badge-light">Reunión</span>
                    <span *ngIf="t.ajuste" class="badge badge-primary">Ajustado: {{ nombreTipoAjuste(t.ajuste.tipo) }}<ng-container *ngIf="t.minutos_permiso"> {{ t.minutos_permiso }} min</ng-container></span>
                    <span *ngIf="t.inicio_jornada" class="text-muted">· inició {{ hora(t.inicio_jornada) }}</span>
                    <span *ngIf="t.fin_jornada" class="text-muted">· terminó {{ hora(t.fin_jornada) }}</span>
                </div>
                <table *ngIf="t.visitas.length" class="table table-sm table-bordered tabla">
                    <thead>
                        <tr>
                            <th>Lugar</th>
                            <th>Llegada</th>
                            <th>Salida</th>
                            <th>Tiempo en lugar</th>
                            <th>Traslado desde el anterior</th>
                            <th>Hueco descontado</th>
                            <th>Distancia GPS</th>
                            <th>Foto</th>
                            <th>Observación</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let v of t.visitas" [class.table-danger]="v.error">
                            <td>
                                {{ v.lugar }}
                                <small *ngIf="v.error" class="d-block text-danger">{{ v.error }}</small>
                                <small *ngIf="v.sin_conexion" class="d-block text-muted">marcado sin señal</small>
                            </td>
                            <td>{{ hora(v.llegada) }}</td>
                            <td>{{ hora(v.salida) }}</td>
                            <td>{{ minutos(v.minutos_lugar) }}</td>
                            <td>{{ minutos(v.minutos_traslado) }}</td>
                            <td [class.font-weight-bold]="v.minutos_hueco">{{ v.minutos_hueco ? v.minutos_hueco + ' min' : '0' }}</td>
                            <td [class.text-danger]="v.lejos">{{ v.distancia !== null ? v.distancia + ' m' : '—' }}</td>
                            <td>
                                <a *ngIf="v.foto" [href]="urlFoto(v.foto)" target="_blank" rel="noopener">
                                    <img [src]="urlFoto(v.foto)" alt="Foto de la visita" class="miniatura">
                                </a>
                            </td>
                            <td>{{ v.observacion }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="turno-resultado">
                    <span *ngIf="t.ingreso">
                        Ingreso {{ hora(t.ingreso) }}
                        <ng-container *ngIf="t.ingreso_cuenta">(cuenta desde {{ hora(t.ingreso_cuenta) }})</ng-container>
                        · salida {{ hora(t.salida) || '—' }}
                        <ng-container *ngIf="t.salida_cuenta">(cuenta hasta {{ hora(t.salida_cuenta) }})</ng-container>
                        ·
                    </span>
                    <b>{{ horas(t.minutos_reconocidos) }} h</b> de {{ horas(t.minutos_esperados) }} h
                    <ng-container *ngIf="t.minutos_huecos"> − {{ t.minutos_huecos }} min de hueco</ng-container>
                    <ng-container *ngIf="!t.es_reunion">
                        · {{ t.lugares }} lugares:
                        <b [class.text-success]="t.cumple_meta" [class.text-danger]="!t.cumple_meta">{{ t.cumple_meta ? 'cumple' : 'no cumple la meta de ' + t.minimo_lugares }}</b>
                    </ng-container>
                    <div *ngFor="let a of t.alertas.concat(t.errores)" class="text-danger alerta">{{ a }}</div>
                </div>
            </div>
            <div *ngIf="!dia.turnos.length" class="text-muted">Sin turno este día.</div>
        </div>
        <div *ngIf="!diasDetalle().length" class="text-muted">Sin turnos ni marcaciones en estas fechas.</div>
    </div>
</div>
